/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Size } from './Size';
import {
    SizeFromJSON,
    SizeFromJSONTyped,
    SizeToJSON,
} from './Size';
import type { Chamber } from './Chamber';
import {
    ChamberFromJSON,
    ChamberFromJSONTyped,
    ChamberToJSON,
} from './Chamber';

/**
 * 
 * @export
 * @interface ArrayDetectorLayoutDto
 */
export interface ArrayDetectorLayoutDto {
    /**
     * 
     * @type {string}
     * @memberof ArrayDetectorLayoutDto
     */
    model: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArrayDetectorLayoutDto
     */
    typeNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArrayDetectorLayoutDto
     */
    unit: string | null;
    /**
     * 
     * @type {Size}
     * @memberof ArrayDetectorLayoutDto
     */
    extent: Size;
    /**
     * 
     * @type {Array<number>}
     * @memberof ArrayDetectorLayoutDto
     */
    frames: Array<number> | null;
    /**
     * 
     * @type {Array<Chamber>}
     * @memberof ArrayDetectorLayoutDto
     */
    chambers: Array<Chamber> | null;
    /**
     * 
     * @type {string}
     * @memberof ArrayDetectorLayoutDto
     */
    $type?: ArrayDetectorLayoutDtoTypeEnum;
}


/**
 * @export
 */
export const ArrayDetectorLayoutDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoArrayDetectorLayoutDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.ArrayDetectorLayoutDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ArrayDetectorLayoutDtoTypeEnum = typeof ArrayDetectorLayoutDtoTypeEnum[keyof typeof ArrayDetectorLayoutDtoTypeEnum];



/**
 * Check if a given object implements the ArrayDetectorLayoutDto interface.
 */
export function instanceOfArrayDetectorLayoutDto(value?: unknown): value is ArrayDetectorLayoutDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ArrayDetectorLayoutDtoTypeEnum)[0];
}

export function ArrayDetectorLayoutDtoFromJSON(json: any): ArrayDetectorLayoutDto {
    return ArrayDetectorLayoutDtoFromJSONTyped(json, false);
}

export function ArrayDetectorLayoutDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArrayDetectorLayoutDto {
    if (json == null) {
        return json;
    }
    return {
        
        'model': json['model'],
        'typeNumber': json['typeNumber'],
        'unit': json['unit'],
        'extent': SizeFromJSON(json['extent']),
        'frames': json['frames'],
        'chambers': (json['chambers'] == null ? null : (json['chambers'] as Array<any>).map(ChamberFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ArrayDetectorLayoutDtoToJSON(value?: ArrayDetectorLayoutDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'model': value['model'],
        'typeNumber': value['typeNumber'],
        'unit': value['unit'],
        'extent': SizeToJSON(value['extent']),
        'frames': value['frames'],
        'chambers': (value['chambers'] == null ? null : (value['chambers'] as Array<any>).map(ChamberToJSON)),
        '$type': value['$type'],
    });
}

